import { render, staticRenderFns } from "./filtrosTransac.vue?vue&type=template&id=516f80db&scoped=true"
import script from "./filtrosTransac.vue?vue&type=script&lang=js"
export * from "./filtrosTransac.vue?vue&type=script&lang=js"
import style0 from "./filtrosTransac.vue?vue&type=style&index=0&id=516f80db&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "516f80db",
  null
  
)

export default component.exports